import React from 'react';
import * as PropTypes from 'prop-types';
import {Layout} from 'antd';
import './ContentLayout.less';
import {Outlet} from 'react-router-dom';

const {Content} = Layout;

const ContentLayout = () => {
  return (
    <Content className={'main-content-container'}>
      <Outlet />
    </Content>
  );
};

ContentLayout.propTypes = {navigation: PropTypes.any};

export default ContentLayout;
